<template>
  <div class="overlay">
    <div class="delete-modal">
      <span class="modal-title">
        Are you sure you want to delete "Greeting record" <br />
        module?
        <strong
          >"Set up Routing" module will also be <br />
          deleted.</strong
        >
      </span>
      <div class="modal-buttons-row">
        <div class="cancel-button" @click="onCancel">
          <span>
            Cancel
          </span>
        </div>
        <div class="delete-button" @click="onDelete">
          <span>
            Delete
          </span>
        </div>
      </div>
      <div class="next-show">
        <input v-model="value" type="checkbox" class="check" />
        <p :class="{ 'checked': value }">
          Do not show me this message next time
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteCallMenu',
  props: {
    onDelete: Function,
    onCancel: Function
  },
  data: () => ({
    value: false
  })
};
</script>

<style scoped lang="scss">
.delete-modal {
  position: relative;
  width: 470px;
  height: 220px;
  background: #ffffff;
  border: 1px solid #e8eaed;
  box-sizing: border-box;
  box-shadow: 0px 4px 10px rgba(13, 29, 63, 0.1);
  border-radius: 7px;
  padding: 30px;

  .next-show {
    display: flex;
    margin-top: 10px;
    .check {
    }
    p {
      margin: 0;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: -0.02em;
      color: #c2c7cf;
    }
    p.checked {
      font-weight: 500;
      color: #98a0ad;
    }
  }

  .modal-title {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: #0d1d3f;
  }

  .modal-buttons-row {
    display: flex;
    flex-direction: row;
    margin-top: 35px;
    height: 35px;

    .cancel-button {
      width: 49%;
      opacity: 0.7;
      border: 1px solid #e3e9ee;
      box-sizing: border-box;
      border-radius: 4px;
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: -0.01em;
      color: #98a0ad;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .delete-button {
      width: 49%;
      background: #cc2f2f;
      border-radius: 4px;
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: -0.01em;
      color: #ffffff;
      margin-left: 5px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
